module.exports = __webpack_public_path__ + "media/images/vp/parallax.01.2-c1fc497d54333fed8deef9c25d14c8cc.png";